export const translations = {
  de: {
    brand: "FEASTSTAR",
    nav: {
      howItWorks: "Wie es funktioniert",
      app: "App",
      partner: "Partner werden",
      forGuests: "Für Gäste",
    },
    common: { learnMore: "Mehr erfahren" },
    home: {
      hero: {
        label: "RESTAURANTS, DIE ZU DIR PASSEN",
        h1a: "Essen gehen,",
        h1b: "ohne zu raten.",
        sub: "Feaststar zeigt dir Restaurants, die zu deinen Ernährungspräferenzen, deinen Standards und deinem echten Geschmack passen.",
        ctaPrimary: "App entdecken",
        ctaSecondary: "Restaurant auswählen",
      },
      problem: {
        label: "DAS PROBLEM",
        h2a: "Du weißt oft erst nach dem Essen,",
        h2b: "ob es wirklich zu dir gepasst hat.",
        body: "Speisekarten erzählen selten die ganze Geschichte. Welche Öle werden verwendet? Sind die Zutaten frisch? Kommt das Gemüse aus der Region? Ist wirklich glutenfrei gekocht — oder nur glutenfrei gedacht?\n\nFür Menschen, die bewusst essen, ist Restaurantbesuch oft ein Kompromiss. Feaststar macht daraus eine Entscheidung.",
      },
      solution: {
        label: "DIE LÖSUNG",
        h2a: "Feaststar übersetzt Qualität",
        h2b: "in echte Auswahl.",
        cards: [
          { title: "Präferenzen statt Zufall.", body: "Lege fest, worauf du beim Essen achtest: Zutatenqualität, Bio-Standards, hochwertige Fette, Allergene, Regionalität oder Zubereitung." },
          { title: "Restaurants, die wirklich passen.", body: "Nicht nur nah. Sondern passend. Entdecke Orte, die zu deinen Ernährungsstandards, deinen Vorlieben und deinem Alltag passen — nicht nur zu deinem Standort." },
          { title: "Bewertungen mit Substanz.", body: "Bewerte nicht nur Geschmack und Service, sondern auch Frische, Herkunft, Zusatzstoffe, Zubereitung und Qualität." },
        ],
      },
      howItWorks: {
        label: "SO FUNKTIONIERT ES",
        h2a: "Vier Schritte.",
        h2b: "Bessere Entscheidungen.",
        steps: [
          { title: "Finde Restaurants in deiner Nähe.", body: "Sieh auf einer Karte sofort, welche Restaurants, Cafés und Manufakturen in deiner Umgebung zu deinen Standards passen — farblich kategorisiert nach Match.", screen: "map" },
          { title: "Öffne das passende Profil.", body: "Bildergalerie, Founder- und Transparenz-Partner-Badges, Philosophie, Tags. Alles auf einen Blick — und keine Fake-Bewertungen.", screen: "restaurant" },
          { title: "Prüfe echte Qualität.", body: "Das Qualitäts-Profil mit Score 0–100, gewichtet nach Community-Bewertungen über alle 36 Qualitäts-Kriterien hinweg.", screen: "quality" },
          { title: "Suche gezielt nach Betrieben.", body: "Filter nach Stadt, Präferenzen oder eigenen Standards — und finde Orte, die du sonst nie gefunden hättest.", screen: "search" },
        ],
      },
      criteria: {
        label: "DEINE ERNÄHRUNG. DEINE KRITERIEN.",
        h2a: "Finde Restaurants nach dem,",
        h2b: "was dir wirklich wichtig ist.",
        sub: "Feaststar zeigt nicht nur, wo du essen kannst — sondern welcher Betrieb zu deinen Standards passt.",
        groups: [
          {
            label: "Zutaten & Herkunft",
            tags: [
              "Zutatenqualität","Frische Zutaten","Regionale Zutaten","Saisonale Zutaten",
              "Bio-/Naturstandard","Wenige Zusatzstoffe","Transparente Herkunft",
              "Hochwertige tierische Produkte","Wildfang","Manufaktur-Qualität",
            ],
          },
          {
            label: "Fette & Zubereitung",
            tags: [
              "Seed-oil-free","Ohne industrielle Saatenöle","Hochwertige Fette",
              "Olivenöl · Butter · Ghee","Schonend zubereitet","Frisch gekocht",
              "Hausgemacht","Traditionelle Zubereitung","Fermentierte Lebensmittel",
              "Nicht hochverarbeitet",
            ],
          },
          {
            label: "Ernährung & Verträglichkeit",
            tags: [
              "Glutenfreie Optionen","Laktosefreie Optionen","Vegetarisch-freundlich",
              "Vegan-freundlich","Low-Carb geeignet","Keto-freundlich","Proteinreich",
              "Paleo-orientiert","Allergen-Transparenz","Zuckerarme Optionen",
              "Histaminbewusste Optionen","Clean Eating",
            ],
          },
          {
            label: "Bewertung & Transparenz",
            tags: [
              "Zutatenqualität","Frische","Tierische Qualität","Regionale Herkunft",
              "Bio-/Naturstandard","Hochwertige Fette","Hausgemacht",
              "Schonende Zubereitung","Individuell anpassbar","Allergen-Transparenz",
            ],
          },
        ],
      },
      origin: {
        label: "GERADE IM RESTAURANT?",
        h2a: "Öffne direkt",
        h2b: "das passende Profil.",
        sub: "Scanne den QR-Code oder wähle kurz aus, von welchem Restaurant, Café oder Shop du kommst.",
        searchLabel: "Restaurant suchen",
        searchPlaceholder: "Restaurant, Café oder Shop suchen…",
        availabilityEyebrow: "BALD VERFÜGBAR",
        availabilityBody: "Die Restaurant-Suche wird verfügbar, sobald die Feaststar-App live ist. Du kannst dir hier schon ansehen, wie es aussehen wird.",
        detected: "Restaurant erkannt",
        noResults: "Keine Treffer. Versuche eine andere Suche.",
        openProfile: "Profil öffnen",
        downloadApp: "App herunterladen",
      },
      download: {
        label: "FEASTSTAR APP",
        h1a: "Speichere deine Standards.",
        h1b: "Finde besseres Essen.",
        sub: "Mit Feaststar findest du Restaurants, die zu deiner Ernährung passen — und erkennst Qualität, bevor du bestellst.",
        waitlistHint: "Der Launch wird vorbereitet. Trag dich ein und erfahre als Erster, wann Feaststar verfügbar ist.",
        emailPlaceholder: "Deine E-Mail-Adresse",
        notifyMe: "Launch-Info erhalten",
        waitlistSuccess: "Danke. Wir melden uns, sobald es losgeht.",
        waitlistError: "Es gab einen technischen Fehler. Bitte versuche es erneut.",
      },
      proof: {
        label: "WARUM FEASTSTAR",
        h2a: "Für Menschen, die wissen wollen,",
        h2b: "was sie wirklich essen.",
        cards: [
          { title: "Mehr als Geschmack", body: "Gute Ernährung endet nicht bei „lecker“. Herkunft, Fette, Frische und Zubereitung verändern die Entscheidung." },
          { title: "Für echte Präferenzen", body: "Ob glutenfrei, regional, bio, low-carb oder seed-oil-free — deine Standards bekommen endlich Platz." },
          { title: "Wächst mit jeder Bewertung", body: "Feaststar wird mit jeder ehrlichen Bewertung präziser. Je mehr Menschen ihre Standards teilen, desto besser passt Feaststar zu allen — eine App, die für jeden wächst." },
          { title: "Für bewusstere Entscheidungen", body: "Feaststar hilft dir, schneller zu erkennen, welcher Ort zu dir passt." },
        ],
      },
      partnerTeaser: {
        label: "FÜR RESTAURANTS",
        h2a: "Du führst einen Betrieb,",
        h2b: "der Qualität wirklich lebt?",
        body: "Dann sollte genau diese Qualität sichtbar werden. Feaststar hilft Restaurants, Cafés und Manufakturen dabei, von Gästen gefunden zu werden, die bewusst suchen.",
        ctaPrimary: "Partner werden",
        ctaSecondary: "Mehr erfahren",
      },
      saved: {
        label: "DEINE FEASTSTAR-BIBLIOTHEK",
        h2a: "Behalte gute Orte",
        h2b: "im Blick.",
        sub: "Merke dir passende Restaurants, Cafés und Manufakturen mit einem Tap — und greife später jederzeit darauf zu. Ohne Liste auf dem Handy. Ohne Screenshot-Chaos.",
        bullets: [
          "Speichern in zwei Sekunden — direkt aus jedem Profil.",
          "Wiederfinden, sobald du an einem neuen Ort bist.",
          "Sortiert nach deinen Standards, nicht nach Werbung.",
        ],
      },
      faq: {
        label: "FRAGEN",
        h2: "Was du wissen solltest.",
        items: [
          { q: "Ist Feaststar nur für Bio-Restaurants?", a: "Nein. Feaststar ist für alle Betriebe gedacht, die transparent mit Qualität, Zutaten, Herkunft oder Zubereitung umgehen." },
          { q: "Kann ich meine eigenen Präferenzen einstellen?", a: "Ja. Genau darum geht es. Du kannst angeben, worauf du beim Essen achtest und Restaurants danach besser einordnen." },
          { q: "Was passiert, wenn ich einen QR-Code im Restaurant scanne?", a: "Du wirst zur passenden Feaststar-Seite geführt und kannst das Restaurant auswählen oder direkt zum Profil gelangen, sobald es verbunden ist." },
          { q: "Kann ich Restaurants bewerten?", a: "Ja. Feaststar soll Bewertungen ermöglichen, die tiefer gehen als Sterne — zum Beispiel Zutatenqualität, Frische, Zubereitung und Anpassbarkeit." },
          { q: "Gibt es Feaststar schon überall?", a: "Feaststar wird Schritt für Schritt aufgebaut. Die Seite und App sollen so vorbereitet sein, dass neue Regionen und Partner sauber ergänzt werden können." },
        ],
      },
      footer: {
        cols: { app: "App", restaurantSelect: "Restaurant auswählen", partner: "Partner werden", imprint: "Impressum", privacy: "Datenschutz" },
      },
    },
    partner: {
      hero: {
        label: "FÜR QUALITÄTSGASTRONOMEN",
        h1a: "Ihre Qualität",
        h1b: "wird gesucht.",
        sub: "Feaststar verbindet Gäste, die bewusst essen wollen, mit Restaurants, die das seit Jahren leben.",
        ctaPrimary: "Als Partner bewerben",
        ctaSecondary: "Mehr erfahren",
      },
      problem: {
        label: "DAS PROBLEM",
        h2a: "Gute Küche redet nicht.",
        h2b: "Sie kocht.",
        body: "Die meisten Bewertungsplattformen zeigen alles gleich. Ob ein Restaurant 48-Stunden-Sauerteig bäckt oder Tiefkühlware aufwärmt — der Algorithmus macht keinen Unterschied.\n\nWer wirklich gute Arbeit macht, verliert sichtbare Zeit damit, das zu erklären. Oder er erklärt es gar nicht — und hofft, dass die richtigen Gäste trotzdem kommen.\n\nFeaststar ist für genau diesen Fall gebaut.",
      },
      how: {
        label: "WIE FEASTSTAR FUNKTIONIERT",
        h2a: "Ein Profil, das zeigt,",
        h2b: "was Sie wirklich sind.",
        cards: [
          { title: "Kuratiert, nicht katalogisiert.", body: "Feaststar nimmt nicht jeden Betrieb wahllos auf. Jedes Partnerprofil soll geprüft, sauber angelegt und sinnvoll eingeordnet werden. Das schützt den Standard — und den Wert jedes Profils." },
          { title: "Qualitätsmerkmale als Sprache.", body: "Gäste suchen nicht nur nach „Restaurant in der Nähe“. Sie suchen nach bio, regional, glutenfrei, saisonal, allergen-transparent, hochwertigen Fetten oder frischer Zubereitung." },
          { title: "Kein Aufwand nach der Einrichtung.", body: "Ein Profil. Einmal sauber eingerichtet. Danach arbeitet es passiv für Ihren Betrieb — über QR-Codes, App-Sichtbarkeit und gezielte Nutzer, die genau danach suchen." },
        ],
      },
      demo: {
        label: "IHR PROFIL AUF FEASTSTAR",
        h2a: "So sehen Gäste",
        h2b: "Ihren Betrieb.",
        right: "Jedes Feaststar-Profil zeigt, was klassische Bewertungsplattformen nicht zeigen: Herkunft, Standards, Philosophie und echte Qualität.\n\nGäste, die dieses Profil aufrufen, suchen genau das.",
        mock: {
          name: "Zur Mühle",
          city: "München",
          subline: "Inhabergeführt seit 1987",
          tags: ["Bio-zertifiziert","Saisonal","Regional","Glutenfreie Optionen","Hochwertige Fette"],
          quote: "„Wir beziehen unser Gemüse von vier Höfen innerhalb von 40 Kilometern.“",
          cuisine: "Süddeutsch · Modern · Vegetarisch-freundlich",
          cta: "Profil ansehen →",
        },
      },
      benefits: {
        label: "WAS SIE GEWINNEN",
        h2a: "Das richtige Publikum.",
        h2b: "Nicht mehr. Nicht weniger.",
        cards: [
          { title: "Gäste, die Ihren Standard verstehen.", body: "Feaststar-Nutzer suchen aktiv nach bewusster Ernährung. Sie lesen Zutaten. Sie fragen nach Herkunft. Sie kommen vorbereitet." },
          { title: "Sichtbarkeit ohne klassisches Werbebudget.", body: "Das Profil arbeitet passiv für Ihren Betrieb — über App, QR-Code, Restaurantprofil und gezielte Auffindbarkeit." },
          { title: "Kein Vergleich mit dem Falschen.", body: "Auf Feaststar soll Ihr Betrieb nicht im selben Kontext wie Fast Food, Lieferdienste oder beliebige Masse erscheinen." },
          { title: "Einmalige Einrichtung.", body: "Kein Content-Kalender. Kein tägliches Dashboard. Kein Algorithmus-Spiel. Ein sauberes Profil, das dauerhaft vorbereitet ist." },
        ],
      },
      standards: {
        label: "UNSER ANSPRUCH",
        h2a: "Nicht jeder kommt rein.",
        h2b: "Das ist der Punkt.",
        body: "Feaststar ist kein offenes Verzeichnis. Jeder Betrieb, der aufgenommen wird, sollte mindestens einen klaren Qualitätsstandard erfüllen: bio-zertifiziert, regional bezogen, allergen-transparent, saisonal, handwerklich, frisch gekocht oder nachhaltig geführt.\n\nDiese Grenze zu ziehen ist unbequem. Sie ist auch der Grund, warum das Profil etwas wert ist.",
        tags: [
          "Bio-/Naturstandard","Regionale Bezugsquellen","Saisonale Küche","Frische Zutaten",
          "Hausgemachte Produkte","Handwerkliche Zubereitung","Wenige Zusatzstoffe",
          "Allergen-Transparenz","Glutenfreie Optionen","Laktosefreie Optionen",
          "Vegetarisch-freundlich","Vegan-freundlich","Hochwertige Fette",
          "Ohne industrielle Saatenöle","Schonende Zubereitung","Hochwertige tierische Produkte",
          "Nachhaltige Betriebsführung","Transparente Lieferanten","Functional Food","Fermentierte Lebensmittel",
        ],
      },
      form: {
        label: "PARTNERSCHAFT ANFRAGEN",
        h2a: "Bereit für das",
        h2b: "richtige Publikum?",
        intro: "Füllen Sie das Formular aus. Wir melden uns für ein kurzes Discovery-Gespräch.\n\nKeine Verpflichtung, keine versteckten Kosten.",
        labels: {
          restaurant_name: "NAME DES BETRIEBS *",
          contact_name: "IHR NAME *",
          email: "E-MAIL-ADRESSE *",
          phone: "TELEFON",
          phone_required: "TELEFON *",
          city: "STADT / REGION *",
          dietary_standards: "QUALITÄTSSTANDARDS IHRES BETRIEBS *",
          message: "WAS MACHT IHREN BETRIEB AUS?",
          preferred_contact_method: "BEVORZUGTE KONTAKTMETHODE *",
          best_reachability: "WANN SIND SIE AM BESTEN ERREICHBAR? *",
          preferred_call_timeframe: "GEWÜNSCHTER GESPRÄCHSZEITRAUM",
          website_or_instagram: "WEBSITE ODER INSTAGRAM",
          role: "ROLLE IM BETRIEB",
        },
        placeholders: {
          restaurant_name: "z.B. Zur Mühle",
          contact_name: "Vor- und Nachname",
          email: "kontakt@ihrbetrieb.de",
          phone: "+49",
          city: "z.B. München",
          message: "Kurze Beschreibung Ihrer Küche, Philosophie oder besonderen Standards...",
          website_or_instagram: "Website oder Instagram-Link",
          preferred_call_timeframe: "Wählen…",
          role: "Wählen…",
        },
        contactMethodOptions: [
          { value: "email", label: "E-Mail" },
          { value: "phone", label: "Telefon" },
          { value: "whatsapp", label: "WhatsApp" },
        ],
        reachabilityOptions: [
          "Morgens 8–11 Uhr",
          "Mittags 11–14 Uhr",
          "Nachmittags 14–17 Uhr",
          "Abends 17–20 Uhr",
          "Flexibel",
        ],
        timeframeOptions: [
          "So schnell wie möglich",
          "Diese Woche",
          "Nächste Woche",
          "In den nächsten 30 Tagen",
          "Erst später",
        ],
        roleOptions: [
          "Inhaber/in","Geschäftsführung","Betriebsleitung","Marketing","Mitarbeiter/in","Sonstiges",
        ],
        standardsOptions: [
          "Bio-/Naturstandard","Regional","Saisonal","Vegan-freundlich","Vegetarisch-freundlich",
          "Glutenfreie Optionen","Laktosefreie Optionen","Allergen-Transparenz","Hochwertige Fette",
          "Ohne industrielle Saatenöle","Frische Zutaten","Wenige Zusatzstoffe","Hausgemacht",
          "Handwerk","Schonende Zubereitung","Hochwertige tierische Produkte","Nachhaltig",
          "Functional Food","Fermentierte Lebensmittel","Transparente Lieferanten",
        ],
        submit: "Partnerschaft anfragen",
        belowSubmit: "Kein Vertrag. Kein Risiko. Nur ein Gespräch.",
        successTitle: "Danke. Wir prüfen Ihre Anfrage.",
        successBody: "Wir haben Ihre Anfrage erhalten. Je nach bevorzugter Kontaktmethode melden wir uns für ein kurzes Discovery-Gespräch.",
        error: "Es gab einen technischen Fehler. Bitte versuchen Sie es erneut.",
        validation: {
          required: "Pflichtfeld",
          email: "Bitte gültige E-Mail eingeben",
          standardsMin: "Bitte mindestens eine Auswahl",
          phoneRequired: "Telefon ist erforderlich für diese Kontaktmethode",
          contactMethod: "Bitte Kontaktmethode wählen",
          reachabilityMin: "Bitte mindestens eine Zeit wählen",
        },
      },
      closing: {
        h1a: "Gute Arbeit verdient",
        h1b: "das richtige Publikum.",
        body: "Wenn Sie das hier lesen und sich wiederfinden — dann ist Feaststar für Sie gebaut.",
        cta: "Jetzt bewerben",
      },
    },
    storeBadges: {
      appleSmall: "Download im",
      appleLarge: "App Store",
      googleSmall: "Jetzt bei",
      googleLarge: "Google Play",
    },
    cookie: {
      title: "Cookies & Datenschutz",
      body: "Wir nutzen technisch notwendige Speicherung. Analyse-Cookies (Google Analytics 4) setzen wir nur mit deiner Zustimmung ein, um die Seite zu verbessern.",
      learnMore: "Mehr in der Datenschutzerklärung",
      accept: "Akzeptieren",
      decline: "Ablehnen",
    },
    notify: {
      eyebrow: "BALD VERFÜGBAR",
      h1a: "Verfügbar,",
      h1b: "wenn die App live ist.",
      sub: "Wir benachrichtigen dich persönlich, sobald Feaststar startet — keine Newsletter, keine Spam-Mails. Nur die eine Nachricht, die du wirklich willst.",
      emailLabel: "E-MAIL-ADRESSE *",
      emailPlaceholder: "deine@adresse.de",
      phoneLabel: "TELEFON",
      phonePlaceholder: "+49 …",
      optional: "(optional)",
      cta: "Benachrichtige mich",
      submitting: "Wird gesendet…",
      privacy: "Du erhältst direkt nach dem Absenden eine Bestätigungsmail und eine weitere Nachricht, sobald Feaststar live ist — sonst nichts.",
      newsletterLabel: "Zum Newsletter anmelden — gelegentliche Updates zu Feaststar (kein Spam, jederzeit abmeldbar).",
      successTitle: "Wir melden uns.",
      successBody: "Du bist auf der Liste. Wir haben dir gerade eine Bestätigungsmail geschickt (bitte auch im Spam-Ordner nachschauen). Sobald Feaststar live ist, hörst du als einer der Ersten von uns.",
      successClose: "Schließen",
      close: "Schließen",
      origin: {
        eyebrow: "VERFÜGBAR, WENN DIE APP LIVE IST",
        cta: "Benachrichtige mich beim Launch",
      },
      errors: {
        email: "Bitte gib eine gültige E-Mail-Adresse ein.",
        network: "Etwas ist schiefgelaufen. Bitte versuche es nochmal.",
      },
    },
  },
  en: {
    brand: "FEASTSTAR",
    nav: { howItWorks: "How it works", app: "App", partner: "Become a Partner", forGuests: "For Guests" },
    common: { learnMore: "Learn more" },
    home: {
      hero: {
        label: "RESTAURANTS THAT FIT YOU",
        h1a: "Dine out,",
        h1b: "without guessing.",
        sub: "Feaststar shows you restaurants that match your dietary preferences, your standards, and your real taste.",
        ctaPrimary: "Discover the app",
        ctaSecondary: "Pick a restaurant",
      },
      problem: {
        label: "THE PROBLEM",
        h2a: "You often only know after the meal",
        h2b: "whether it really fit you.",
        body: "Menus rarely tell the whole story. Which oils are used? Are the ingredients fresh? Is the gluten-free option really gluten-free — or just labeled that way?\n\nFor people who eat mindfully, dining out is a compromise. Feaststar turns it into a decision.",
      },
      solution: {
        label: "THE SOLUTION",
        h2a: "Feaststar translates quality",
        h2b: "into real choices.",
        cards: [
          { title: "Preferences, not chance.", body: "Define what matters to you: ingredient quality, organic standards, high-quality fats, allergens, regionality, or preparation." },
          { title: "Restaurants that truly fit.", body: "Not just close. A real match. Discover places that fit your nutritional standards, your preferences and your daily life — not just your location." },
          { title: "Reviews with substance.", body: "Rate not only taste and service, but freshness, origin, additives, preparation and quality." },
        ],
      },
      howItWorks: {
        label: "HOW IT WORKS",
        h2a: "Four steps.",
        h2b: "Better decisions.",
        steps: [
          { title: "Find restaurants near you.", body: "See on a live map which restaurants, cafés and producers around you match your standards — colour-coded by match.", screen: "map" },
          { title: "Open the right profile.", body: "Image gallery, founder and transparency partner badges, philosophy, tags. Everything at a glance — without fake reviews.", screen: "restaurant" },
          { title: "Check real quality.", body: "The Quality Profile with a 0–100 score, weighted by community ratings across 36 quality criteria.", screen: "quality" },
          { title: "Search precisely.", body: "Filter by city, preferences or your own standards — and find places you'd never have discovered otherwise.", screen: "search" },
        ],
      },
      criteria: {
        label: "YOUR DIET. YOUR CRITERIA.",
        h2a: "Find restaurants by",
        h2b: "what actually matters.",
        sub: "Feaststar doesn't just show where you can eat — it shows which place fits your standards.",
        groups: [
          { label: "Ingredients & origin", tags: ["Ingredient quality","Fresh ingredients","Regional sourcing","Seasonal sourcing","Organic / natural","Few additives","Transparent origin","Quality animal products","Wild-caught","Artisan quality"] },
          { label: "Fats & preparation", tags: ["Seed-oil-free","No industrial seed oils","High-quality fats","Olive oil · Butter · Ghee","Gentle preparation","Freshly cooked","House-made","Traditional preparation","Fermented foods","Not ultra-processed"] },
          { label: "Diet & tolerance", tags: ["Gluten-free options","Lactose-free options","Vegetarian-friendly","Vegan-friendly","Low-carb friendly","Keto-friendly","Protein-rich","Paleo-aligned","Allergen transparency","Low-sugar options","Histamine-aware","Clean Eating"] },
          { label: "Ratings & transparency", tags: ["Ingredient quality","Freshness","Animal quality","Regional origin","Organic / natural","High-quality fats","House-made","Gentle preparation","Customizable","Allergen transparency"] },
        ],
      },
      origin: {
        label: "AT A RESTAURANT RIGHT NOW?",
        h2a: "Open the right",
        h2b: "profile in one tap.",
        sub: "Scan the QR code or quickly choose which restaurant, café or shop you're at.",
        searchLabel: "Search restaurant",
        searchPlaceholder: "Search restaurant, café or shop…",
        availabilityEyebrow: "COMING SOON",
        availabilityBody: "Restaurant search will be available once the Feaststar app goes live. For now you can preview what it will look like.",
        detected: "Restaurant detected",
        noResults: "No matches. Try another search.",
        openProfile: "Open profile",
        downloadApp: "Download the app",
      },
      download: {
        label: "FEASTSTAR APP",
        h1a: "Save your standards.",
        h1b: "Find better food.",
        sub: "With Feaststar you find restaurants that match your nutrition — and recognize quality before you order.",
        waitlistHint: "Launch is being prepared. Sign up to be the first to know when Feaststar goes live.",
        emailPlaceholder: "Your email address",
        notifyMe: "Get launch info",
        waitlistSuccess: "Thank you. We'll be in touch when we launch.",
        waitlistError: "Something went wrong. Please try again.",
      },
      proof: {
        label: "WHY FEASTSTAR",
        h2a: "For people who want to know",
        h2b: "what they actually eat.",
        cards: [
          { title: "More than taste", body: "Good nutrition doesn't end at 'tasty'. Origin, fats, freshness and preparation change the decision." },
          { title: "For real preferences", body: "Gluten-free, regional, organic, low-carb or seed-oil-free — your standards finally have a place." },
          { title: "Grows with every review", body: "Feaststar gets sharper with every honest review. The more people share their standards, the better Feaststar fits everyone — an app that grows for all." },
          { title: "For more conscious choices", body: "Feaststar helps you quickly recognize which place fits you." },
        ],
      },
      partnerTeaser: {
        label: "FOR RESTAURANTS",
        h2a: "Do you run a place",
        h2b: "that actually lives quality?",
        body: "Then that quality deserves to be seen. Feaststar helps restaurants, cafés and producers be found by guests who consciously search.",
        ctaPrimary: "Become a Partner",
        ctaSecondary: "Learn more",
      },
      saved: {
        label: "YOUR FEASTSTAR LIBRARY",
        h2a: "Keep great places",
        h2b: "in view.",
        sub: "Bookmark restaurants, cafés and producers that fit you — and come back to them whenever you need. No screenshot chaos. No lost lists.",
        bullets: [
          "Save in two seconds — straight from any profile.",
          "Re-discover them whenever you're somewhere new.",
          "Sorted by your standards, not by ads.",
        ],
      },
      faq: {
        label: "QUESTIONS",
        h2: "What you should know.",
        items: [
          { q: "Is Feaststar only for organic restaurants?", a: "No. Feaststar is for any business transparent about quality, ingredients, origin or preparation." },
          { q: "Can I set my own preferences?", a: "Yes. That's the point. You define what you care about and restaurants are classified accordingly." },
          { q: "What happens when I scan a QR code at a restaurant?", a: "You're taken to the matching Feaststar page and can select the restaurant or open its profile directly." },
          { q: "Can I rate restaurants?", a: "Yes. Feaststar enables ratings that go beyond stars — ingredient quality, freshness, preparation and customizability." },
          { q: "Is Feaststar available everywhere?", a: "Feaststar is being built step by step. The site and app are designed so new regions and partners can be added cleanly." },
        ],
      },
      footer: { cols: { app: "App", restaurantSelect: "Pick a restaurant", partner: "Become a Partner", imprint: "Imprint", privacy: "Privacy" } },
    },
    partner: {
      hero: {
        label: "FOR QUALITY RESTAURATEURS",
        h1a: "Your quality",
        h1b: "is being searched.",
        sub: "Feaststar connects guests who eat mindfully with restaurants that have lived that for years.",
        ctaPrimary: "Apply as Partner",
        ctaSecondary: "Learn more",
      },
      problem: {
        label: "THE PROBLEM",
        h2a: "Good cooking doesn't talk.",
        h2b: "It cooks.",
        body: "Most rating platforms treat everything equally. Whether a restaurant ferments sourdough for 48 hours or reheats frozen food — the algorithm doesn't distinguish.\n\nThose who do real work lose visible time explaining it. Or they don't explain at all — and hope the right guests show up anyway.\n\nFeaststar is built for exactly this case.",
      },
      how: {
        label: "HOW FEASTSTAR WORKS",
        h2a: "One profile that shows",
        h2b: "what you really are.",
        cards: [
          { title: "Curated, not catalogued.", body: "Feaststar doesn't onboard everyone. Each partner profile is reviewed, cleanly set up and meaningfully classified. That protects the standard — and the value of every profile." },
          { title: "Quality as language.", body: "Guests search not just for 'restaurant nearby'. They search for organic, regional, gluten-free, seasonal, allergen-transparent, high-quality fats or fresh preparation." },
          { title: "No effort after setup.", body: "One profile. Set up once. After that, it works passively — via QR codes, app visibility and targeted users searching exactly for that." },
        ],
      },
      demo: {
        label: "YOUR PROFILE ON FEASTSTAR",
        h2a: "This is how guests",
        h2b: "see your business.",
        right: "Every Feaststar profile shows what traditional rating platforms don't: origin, standards, philosophy and real quality.\n\nGuests who open this profile are looking for exactly that.",
        mock: {
          name: "Zur Mühle", city: "Munich", subline: "Family-owned since 1987",
          tags: ["Organic-certified","Seasonal","Regional","Gluten-free options","Quality fats"],
          quote: "“We source our vegetables from four farms within 40 km.”",
          cuisine: "Southern German · Modern · Vegetarian-friendly",
          cta: "View profile →",
        },
      },
      benefits: {
        label: "WHAT YOU GAIN", h2a: "The right audience.", h2b: "Nothing more. Nothing less.",
        cards: [
          { title: "Guests who understand your standard.", body: "Feaststar users actively search for mindful eating. They read ingredients. They ask about origin. They come prepared." },
          { title: "Visibility without classic ad budget.", body: "The profile works passively — via app, QR code, restaurant profile and targeted discoverability." },
          { title: "No comparison to the wrong things.", body: "On Feaststar, your business won't appear next to fast food, delivery services or random mass listings." },
          { title: "One-time setup.", body: "No content calendar. No daily dashboard. No algorithm gaming. One clean profile that's prepared for the long haul." },
        ],
      },
      standards: {
        label: "OUR STANDARD", h2a: "Not everyone gets in.", h2b: "That's the point.",
        body: "Feaststar is not an open directory. Every business onboarded should meet at least one clear quality standard: organic-certified, regional sourcing, allergen-transparent, seasonal, artisan, freshly cooked or sustainably run.\n\nDrawing that line is uncomfortable. It's also why the profile is worth something.",
        tags: [
          "Organic / natural","Regional sourcing","Seasonal kitchen","Fresh ingredients",
          "House-made products","Artisan preparation","Few additives","Allergen transparency",
          "Gluten-free options","Lactose-free options","Vegetarian-friendly","Vegan-friendly",
          "High-quality fats","No industrial seed oils","Gentle preparation","Quality animal products",
          "Sustainable operations","Transparent suppliers","Functional food","Fermented foods",
        ],
      },
      form: {
        label: "REQUEST PARTNERSHIP", h2a: "Ready for the", h2b: "right audience?",
        intro: "Fill out the form. We'll be in touch for a short discovery call.\n\nNo obligation, no hidden costs.",
        labels: {
          restaurant_name: "BUSINESS NAME *", contact_name: "YOUR NAME *", email: "EMAIL ADDRESS *",
          phone: "PHONE", phone_required: "PHONE *", city: "CITY / REGION *",
          dietary_standards: "QUALITY STANDARDS OF YOUR BUSINESS *",
          message: "WHAT MAKES YOUR BUSINESS UNIQUE?",
          preferred_contact_method: "PREFERRED CONTACT METHOD *",
          best_reachability: "BEST TIME TO REACH YOU *",
          preferred_call_timeframe: "PREFERRED CONVERSATION TIMEFRAME",
          website_or_instagram: "WEBSITE OR INSTAGRAM", role: "ROLE IN THE BUSINESS",
        },
        placeholders: {
          restaurant_name: "e.g. Zur Mühle", contact_name: "First and last name",
          email: "contact@yourbusiness.com", phone: "+49", city: "e.g. Munich",
          message: "Short description of your kitchen, philosophy or special standards...",
          website_or_instagram: "Website or Instagram link",
          preferred_call_timeframe: "Choose…", role: "Choose…",
        },
        contactMethodOptions: [
          { value: "email", label: "Email" },
          { value: "phone", label: "Phone" },
          { value: "whatsapp", label: "WhatsApp" },
        ],
        reachabilityOptions: ["Mornings 8–11", "Midday 11–14", "Afternoon 14–17", "Evening 17–20", "Flexible"],
        timeframeOptions: ["As soon as possible","This week","Next week","Within 30 days","Later"],
        roleOptions: ["Owner","Management","Operations","Marketing","Staff","Other"],
        standardsOptions: [
          "Organic / natural","Regional","Seasonal","Vegan-friendly","Vegetarian-friendly",
          "Gluten-free options","Lactose-free options","Allergen transparency","High-quality fats",
          "No industrial seed oils","Fresh ingredients","Few additives","House-made","Artisan",
          "Gentle preparation","Quality animal products","Sustainable","Functional food",
          "Fermented foods","Transparent suppliers",
        ],
        submit: "Request partnership",
        belowSubmit: "No contract. No risk. Just a conversation.",
        successTitle: "Thank you. We'll review your request.",
        successBody: "We received your request. Based on your preferred contact method, we'll reach out for a short discovery call.",
        error: "Something went wrong. Please try again.",
        validation: {
          required: "Required", email: "Please enter a valid email", standardsMin: "Please select at least one",
          phoneRequired: "Phone is required for this contact method",
          contactMethod: "Please choose a contact method",
          reachabilityMin: "Please choose at least one time",
        },
      },
      closing: {
        h1a: "Good work deserves", h1b: "the right audience.",
        body: "If you've read this far and recognize yourself — Feaststar is built for you.",
        cta: "Apply now",
      },
    },
    storeBadges: { appleSmall: "Download on the", appleLarge: "App Store", googleSmall: "Get it on", googleLarge: "Google Play" },
    cookie: {
      title: "Cookies & Privacy",
      body: "We use technically necessary storage. Analytics cookies (Google Analytics 4) are only set with your consent to help us improve the site.",
      learnMore: "More in our Privacy Policy",
      accept: "Accept",
      decline: "Decline",
    },
    notify: {
      eyebrow: "COMING SOON",
      h1a: "Available",
      h1b: "when the app goes live.",
      sub: "We'll let you know personally the moment Feaststar launches — no newsletters, no spam. Just the one message you actually want.",
      emailLabel: "EMAIL ADDRESS *",
      emailPlaceholder: "you@email.com",
      phoneLabel: "PHONE",
      phonePlaceholder: "+1 …",
      optional: "(optional)",
      cta: "Notify me",
      submitting: "Sending…",
      privacy: "You'll receive a confirmation email right after submitting and one more message once Feaststar goes live — nothing else.",
      successTitle: "We'll be in touch.",
      successBody: "You're on the list. We just sent a confirmation email (please also check your spam folder). As soon as Feaststar is live, you'll hear from us first.",
      successClose: "Close",
      close: "Close",
      origin: {
        eyebrow: "AVAILABLE WHEN THE APP IS LIVE",
        cta: "Notify me at launch",
      },
      errors: {
        email: "Please enter a valid email address.",
        network: "Something went wrong. Please try again.",
      },
    },
  },
};
